import Model from './Model'

// Sprint 1 Open to Work — company-side candidate search/profile.
// NOTE: vue-api-query resolves `resource()` directly against baseURL with no
// implicit nesting, so the literal endpoint path (`open-to-work/candidates`,
// per the build spec's Shared Data Model routes) has to be returned here —
// returning just 'candidates' would hit `${apiUrl}/candidates`, not the real
// `${apiUrl}/open-to-work/candidates` endpoint.
export default class Candidate extends Model {
  resource() {
    return 'open-to-work/candidates'
  }

  // API contract paginates with `per_page` (see build spec's Shared Data
  // Model query params), not vue-api-query's default `limit` param name.
  parameterNames() {
    return {
      ...super.parameterNames(),
      limit: 'per_page',
    }
  }
}
